<template>
  <div>
    <header
      class="header"
      :class="{ '_bg-md-green-main': openedMenu || userMenu }"
    >
      <section class="container">
        <div class="d-flex justify-between align-center _py-3 _px-md-4">
          <AppLogo :openedMenu="openedMenu || userMenu" />
          <AppSearch class="d-none d-xl-block" />
          <section class="header__ctrl d-flex align-center">
            <AppBtn
              v-if="user && !Object.keys(user).length && false"
              class="header__btn _py-2 _px-lg-3 _br-sm-1 _px-md-0 _mr-lg-6 _mr-4 d-none d-xl-flex"
              :btnClass="'btn_secondary'"
              @click.native="openAuth"
            >
              <span class="d-none d-xl-inline _fs-16 _lh-24">{{
                $t('interface.login')
              }}</span>
              <svg
                class="d-xl-none"
                width="16"
                height="16"
                viewBox="0 0 12 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 8C8.20914 8 10 6.20914 10 4C10 1.79086 8.20914 0 6 0C3.79086 0 2 1.79086 2 4C2 6.20914 3.79086 8 6 8Z"
                  fill="#77BB2F"
                />
                <path
                  d="M6 9.33325C2.68781 9.33694 0.0036875 12.0211 0 15.3333C0 15.7014 0.298469 15.9999 0.666656 15.9999H11.3333C11.7015 15.9999 12 15.7014 12 15.3333C11.9963 12.0211 9.31219 9.33691 6 9.33325Z"
                  fill="#77BB2F"
                />
              </svg>
            </AppBtn>
            <AppBtn
              v-if="user && !Object.keys(user).length"
              class="header__btn _py-2 _px-lg-6 _br-sm-1 _px-md-0 _mr-lg-6 _mr-4 d-none d-xl-flex"
              :btnClass="'btn_secondary'"
              @click.native="openSSOAuth"
            >
              <span class="d-none d-xl-inline _fs-16 _lh-24">{{
                $t('interface.login')
              }}</span>
              <svg
                class="d-xl-none"
                width="16"
                height="16"
                viewBox="0 0 12 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 8C8.20914 8 10 6.20914 10 4C10 1.79086 8.20914 0 6 0C3.79086 0 2 1.79086 2 4C2 6.20914 3.79086 8 6 8Z"
                  fill="#77BB2F"
                />
                <path
                  d="M6 9.33325C2.68781 9.33694 0.0036875 12.0211 0 15.3333C0 15.7014 0.298469 15.9999 0.666656 15.9999H11.3333C11.7015 15.9999 12 15.7014 12 15.3333C11.9963 12.0211 9.31219 9.33691 6 9.33325Z"
                  fill="#77BB2F"
                />
              </svg>
            </AppBtn>
            <AppBtn
              v-if="user && !Object.keys(user).length"
              class="header__btn _py-2 _px-lg-6 _br-sm-1 _px-md-0 _mr-lg-6 _mr-4 d-xl-none"
              :btnClass="'btn_secondary'"
              @click.native="openSSOAuth"
            >
              <svg
                class="d-xl-none"
                width="16"
                height="16"
                viewBox="0 0 12 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 8C8.20914 8 10 6.20914 10 4C10 1.79086 8.20914 0 6 0C3.79086 0 2 1.79086 2 4C2 6.20914 3.79086 8 6 8Z"
                  fill="#77BB2F"
                />
                <path
                  d="M6 9.33325C2.68781 9.33694 0.0036875 12.0211 0 15.3333C0 15.7014 0.298469 15.9999 0.666656 15.9999H11.3333C11.7015 15.9999 12 15.7014 12 15.3333C11.9963 12.0211 9.31219 9.33691 6 9.33325Z"
                  fill="#77BB2F"
                />
              </svg>
            </AppBtn>
            <div class="d-flex _mr-6" v-else @click="openUserMenu">
              <div class="header__avatar">
                <img v-if="user.photo" :src="'/' + user.photo" alt="user" />
                <div v-else class="_bg-light-grey _br--2 _pa-2">
                  <svg
                    viewBox="0 0 52 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M43.3337 45.5V41.1667C43.3337 38.8681 42.4206 36.6637 40.7953 35.0384C39.1699 33.4131 36.9655 32.5 34.667 32.5H17.3337C15.0351 32.5 12.8307 33.4131 11.2054 35.0384C9.58008 36.6637 8.66699 38.8681 8.66699 41.1667V45.5"
                      stroke="#B2B4B2"
                      stroke-width="4.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M25.9997 23.8333C30.7861 23.8333 34.6663 19.9531 34.6663 15.1667C34.6663 10.3802 30.7861 6.5 25.9997 6.5C21.2132 6.5 17.333 10.3802 17.333 15.1667C17.333 19.9531 21.2132 23.8333 25.9997 23.8333Z"
                      stroke="#B2B4B2"
                      stroke-width="4.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div
                  class="header__avatar-menu d-flex _px-4 _py-6"
                  v-if="userMenu"
                >
                  <div
                    class="header-username d-flex align-center _fs-16 _lh-24 _fw-400"
                  >
                    {{ user.username }}
                  </div>
                  <AppBtn
                    class="d-flex justify-center _mt-6 _mt-sm-4 _mr-md-8 _mr-sm-0 _ml-md-auto _ml-sm-0 _mt-md-0"
                  >
                    <div @click="cabinetClick()" class="_tc-white _py-2 _px-7">
                      <span class="_fs-16 _lh-24">{{
                        $t('interface.cabinet')
                      }}</span>
                    </div>
                  </AppBtn>
                  <AppBtn
                    @click.native="logout"
                    class="logout_btn d-flex justify-center _mt-4 _mt-sm-4 _mt-xl-4 _mt-md-0"
                    :btnClass="'btn_secondary'"
                  >
                    <span class="d-flex _fs-16 _lh-24 _py-2 _px-7"
                      ><svg
                        class="_mr-1"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.5 21H5.5C4.96957 21 4.46086 20.7893 4.08579 20.4142C3.71071 20.0391 3.5 19.5304 3.5 19V5C3.5 4.46957 3.71071 3.96086 4.08579 3.58579C4.46086 3.21071 4.96957 3 5.5 3H9.5M16.5 17L21.5 12M21.5 12L16.5 7M21.5 12H9.5"
                          stroke="#629727"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {{ $t('interface.logout') }}
                    </span>
                  </AppBtn>
                </div>
              </div>
              <span
                class="_ml-2 header__cabinet-link _my-auto"
                :class="{
                  '_tc-white': $root.isMobile && (openedMenu || userMenu),
                  '_tc-green-main':
                    !$root.isMobile ||
                    ($root.isMobile && !openedMenu && !userMenu),
                }"
                >{{ $t('interface.cabinet') }}</span
              >
            </div>

            <div
              class="header__auth-type-menu d-flex _py-8 _px-8"
              v-if="authType"
            >
              <AppBtn
                class="d-flex justify-center _mt-6 _mt-sm-4 _mr-sm-0 _mx-md-auto _ml-sm-0 _mt-md-0"
                :btnClass="'btn_primary'"
                @click.native="openAuth"
              >
                <span class="_fs-16 _lh-24 _py-2 _px-7">{{
                  $t('interface.login')
                }}</span>
              </AppBtn>
              <AppBtn
                class="d-flex justify-center _mt-6 _mt-sm-4 _mr-sm-0 _mx-md-auto _ml-sm-0 _mt-md-0"
                :btnClass="'btn_primary'"
                @click.native="openSSOAuth"
              >
                <span class="_fs-16 _lh-24 _py-2 _px-7">
                  Войти&nbsp;через&nbsp;MyHerbalife
                </span>
              </AppBtn>
            </div>

            <AppBtn
              @click.native="openMenu"
              class="header__btn d-xl-none _br-sm-1"
              :btnClass="`btn_primary ${
                openedMenu || userMenu ? '_bg-white' : ''
              }`"
            >
              <svg
                v-if="!openedMenu"
                :class="[userMenu ? '_tc-green-main' : '_tc-white']"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1H9"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 5H9"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 9H9"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <svg
                v-else
                width="8"
                height="16"
                viewBox="0 0 8 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 11L7 5"
                  stroke="#061B36"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 5L7 11"
                  stroke="#061B36"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </AppBtn>

            <AppBtn
              v-if="false"
              @click.native="dataLayerPush()"
              class="d-none d-xl-flex _mr-6"
            >
              <div class="_py-2 _px-3 _tc-white">
                <span class="_fs-16 _lh-24">{{ $t('interface.help') }}</span>
              </div>
            </AppBtn>

            <LocaleSwitcher class="d-none d-xl-flex" />
          </section>
        </div>
      </section>

      <AppNavigation class="d-none d-xl-flex" />
      <AppMobileMenu v-if="openedMenu" />
    </header>
    <div v-if="openedMenu" class="menu__overlay" @click="openMenu()"></div>
  </div>
</template>

<script>
// import Android from 'icons/Android'
import { bus } from '@/main'
import AppLogo from '@/layouts/components/AppLogo'
import AppBtn from '@/components/UI/buttons/AppBtn'
import AppNavigation from '@/layouts/components/AppNavigation'
import LocaleSwitcher from '@/layouts/components/LocaleSwitcher'
import AppSearch from '@/layouts/components/AppSearch.vue'
import AppMobileMenu from '@/layouts/components/AppMobileMenu.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AppHeader',
  components: {
    AppBtn,
    AppLogo,
    AppNavigation,
    LocaleSwitcher,
    AppSearch,
    AppMobileMenu,
  },
  data: () => ({
    openedMenu: false,
    userMenu: false,
    authType: false,
  }),
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    ...mapActions(['clearSearch', 'fetchLogout']),
    openAuth(state) {
      bus.$emit('openAuth', 'authState', state)
      this.authType = false
      if (this.$gtm) {
        this.$gtm.push({
          event: 'ev_login',
        })
      }
    },
    openSSOAuth(state) {
      bus.$emit('openAuth', 'authSSOState', state)
      this.authType = false
      // if (this.$gtm) {
      //   this.$gtm.push({
      //     event: 'ev_login',
      //   })
      // }
    },
    openAuthType() {
      this.authType = !this.authType
      bus.$emit('scrollLock', this.authType)
      this.clearSearch()
      this.userMenu = false
    },
    dataLayerPush() {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'ev_click_search',
        })
      }
      window.open('https://t.me/+fR3ci9egP2tkZjc6')
    },
    openMenu() {
      this.openedMenu = !this.openedMenu
      bus.$emit('scrollLock', this.openedMenu)
      this.clearSearch()
      this.userMenu = false
    },
    openUserMenu() {
      this.userMenu = !this.userMenu
      bus.$emit('scrollLock', this.userMenu)
      this.openedMenu = false
      if (this.$gtm) {
        this.$gtm.push({
          event: 'ev_lk_icon',
        })
      }
    },
    cabinetClick() {
      this.$router.push(this.helpers.buildRoute({ name: 'Cabinet' }))
      if (this.$gtm) {
        this.$gtm.push({
          event: 'ev_lk_menu',
          param_value: this.$t('interface.cabinet'),
        })
      }
    },
    logout() {
      this.fetchLogout()
      this.userMenu = false
      bus.$emit('scrollLock', false)
      if (this.$gtm) {
        this.$gtm.push({
          event: 'ev_lk_menu',
          param_value: this.$t('interface.logout'),
        })
      }
      if (this.$route.name !== 'Home') {
        this.$router.push(this.helpers.buildRoute({ name: 'Home' }))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  z-index: 1000;
  &__cabinet-link {
    cursor: pointer;
    white-space: nowrap;

    @media screen and (max-width: 374px) {
      display: none;
    }
  }
  &__auth-type {
    &-menu {
      flex-direction: column;
      position: absolute;
      top: 70px;
      left: 0;
      width: 224px;
      height: auto;
      background: #ffffff;
      border: 1px solid #f8f8f8;
      box-shadow: 7px 7px 4px rgba(0, 0, 0, 0.01),
        4px 4px 3px rgba(0, 0, 0, 0.05), 2px 2px 3px rgba(0, 0, 0, 0.09),
        0px 0px 1px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      z-index: 10000;
      @media screen and (max-width: 1220px) {
        flex-direction: row;
        top: 55px;
        right: 0px;
        width: 100%;

        border-radius: 0px;
      }
      @media screen and (max-width: 743px) {
        flex-direction: column;
        top: 55px;
        right: 0px;
        width: 100%;
        padding-bottom: 30px;
        border-radius: 0px;
      }
    }
  }
  &__avatar {
    border: 2px solid #77bb2f;
    border-radius: 16px;
    flex-shrink: 0;
    position: relative;
    cursor: pointer;
    width: 38px;
    height: 38px;
    @media screen and (max-width: 1220px) {
      position: static;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      border-radius: 16px;
    }
    &-menu {
      flex-direction: column;
      position: absolute;
      top: 72px;
      left: 0;
      width: 224px;
      height: auto;
      background: #ffffff;
      border: 1px solid #f8f8f8;
      box-shadow: 7px 7px 4px rgba(0, 0, 0, 0.01),
        4px 4px 3px rgba(0, 0, 0, 0.05), 2px 2px 3px rgba(0, 0, 0, 0.09),
        0px 0px 1px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      z-index: 10000;
      @media screen and (max-width: 1220px) {
        flex-direction: row;
        top: 62px;
        right: 0px;
        width: 100%;
        height: 86px;
        border-radius: 0px;
      }
      @media screen and (max-width: 743px) {
        flex-direction: column;
        top: 62px;
        right: 0px;
        width: 100%;
        height: 180px;
        border-radius: 0px;
      }
    }
  }
}
.header__btn {
  transition: none !important;
  @media screen and (max-width: 1220px) {
    width: 32px;
    height: 32px;
  }
}
.menu__overlay {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999;
}
</style>
